var chunkMapping = {
	"1360": [
		41360
	],
	"2498": [
		32498
	],
	"3149": [
		33149
	]
};
var idToExternalAndNameMapping = {
	"32498": [
		"default",
		"./App",
		47908
	],
	"33149": [
		"default",
		"./PolarisInterviews",
		47908
	],
	"41360": [
		"default",
		"./PolarisProvider",
		47908
	]
};
var idToRemoteMap = {
	"32498": [
		{
			"externalType": "script",
			"name": "polaris",
			"externalModuleId": 47908
		}
	],
	"33149": [
		{
			"externalType": "script",
			"name": "polaris",
			"externalModuleId": 47908
		}
	],
	"41360": [
		{
			"externalType": "script",
			"name": "polaris",
			"externalModuleId": 47908
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}